import {
  ArrowUpRight,
  BarChart3,
  FolderKanban,
  Target,
  TrendingUp,
  Wallet,
} from 'lucide-react';

const features = [
  {
    icon: Target,
    title: 'POC Selection',
    desc: 'Identify the right POCs to target, based on data-driven insights and historical performance.',
    wide: true,
  },
  {
    icon: Wallet,
    title: 'Budget Optimization',
    desc: 'Streamline your ad spend with machine learning algorithms to deliver maximum result with minimal input.',
    wide: true,
  },
  {
    icon: FolderKanban,
    title: 'Efficient Ads Publishing',
    desc: 'Our user interface enhances process efficiency by seamlessly aggregating files, dashboards, and other resources in one place.',
    wide: false,
  },
  {
    icon: TrendingUp,
    title: 'Forecasting and ROI',
    desc: 'Leverage advanced forecasting techniques to quantify campaign performance and calculate accurate ROI.',
    wide: false,
  },
  {
    icon: BarChart3,
    title: 'Post-Campaign Analysis',
    desc: 'Gain insights into campaign effectiveness with our intuitive dashboard that highlights key performance indicators.',
    wide: false,
  },
];

export default function FeatureTiles() {
  return (
    <section className="landing-section landing-section--features">
      <div className="landing-section-head">
        <h2 className="section-title">Features That Drive Results</h2>
      </div>

      <div className="landing-tiles-grid landing-tiles-grid--features">
        {features.map(({ icon: Icon, title, desc, wide }) => (
          <article
            key={title}
            className={`landing-tile${wide ? ' landing-tile--wide' : ''}`}
          >
            <div className="landing-tile-top">
              <span className="landing-tile-icon">
                <Icon size={24} strokeWidth={1.6} />
              </span>
              <ArrowUpRight className="landing-tile-arrow" size={18} strokeWidth={1.6} />
            </div>
            <h3 className="landing-tile-title">{title}</h3>
            <p className="landing-tile-desc">{desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
